import React from "react";
import { useSelector } from "react-redux";
import { Outlet, Route, Routes } from "react-router-dom";
import LeftSideLayout from "../../components/common/settings/left-side-data";
import ChangePassword from "../../components/common/settings/settings-details/change-password";
import Faqs from "../../components/common/settings/settings-details/faqs";
import HelpAndSupports from "../../components/common/settings/settings-details/help-and-support";
import MyBudgets from "../../components/common/settings/settings-details/my-budgets";
import Notifications from "../../components/common/settings/settings-details/notifications";
import PartnersSponsers from "../../components/common/settings/settings-details/partners-sponsers";
import PrivacyPolicySetting from "../../components/common/settings/settings-details/privacy-policy";
import Resources from "../../components/common/settings/settings-details/resources";
import TermsAndConditionsSettings from "../../components/common/settings/settings-details/terms-and-conditions";
import SettingsCommonHeader from "../../components/common/settings/SettingsCommonHeader";
import { routePaths } from "../../routing/routePaths";
import EditForm from "./edit-form";

const SettingsMain = () => {
  const showMenuFlag = useSelector((state) => state.common.showMenu);
  const showSubMenuFlag = useSelector((state) => state.common.showSubMenu);
  return (
    <>
      <div className="container-fluid settings-fluid">
        <div className="container">
          <div className="row">
            <SettingsCommonHeader />
          </div>
          <div className="row">
            <div className="col-12">
              <div
                className={`left-side-common-tabs ${
                  showMenuFlag || showSubMenuFlag ? "show" : "hide"
                }`}
              >
                <LeftSideLayout />
              </div>
              <div
                className={`right-side-setting-details ${
                  showMenuFlag || showSubMenuFlag ? "hide" : "show"
                }`}
              >
                <Routes>
                  <Route
                    path={routePaths.notifications}
                    element={<Notifications />}
                  />
                  <Route path={routePaths.editForm} element={<EditForm />} />
                  <Route
                    path={routePaths.changePassword}
                    element={<ChangePassword />}
                  />
                  <Route
                    path={routePaths.settingsPrivacyPolicy}
                    element={<PrivacyPolicySetting />}
                  />
                  <Route
                    path={routePaths.settingsTemsNConditions}
                    element={<TermsAndConditionsSettings />}
                  />
                  <Route
                    path={routePaths.helpAndSupport}
                    element={<HelpAndSupports />}
                  />
                  <Route
                    path={routePaths.partnersSponsors}
                    element={<PartnersSponsers />}
                  />
                  <Route path={routePaths.faqs} element={<Faqs />} />
                  <Route path={routePaths.myBudgets} element={<MyBudgets />} />
                  <Route path={routePaths.resources} element={<Resources />} />
                  <Route path={routePaths.splashScreen} element={<></>} />
                </Routes>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsMain;
